import React from 'react';
import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import CreateEpisode from '../CreateEpisode';
import { validate } from '../../episode';
import { submitCreateEpisodeForm } from '../../episodes';

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(submitCreateEpisodeForm(data)),
});

export default connect(
  null,
  mapDispatchToProps
)(
  reduxForm({
    form: 'createEpisode',
    validate,
  })(CreateEpisode)
);
